import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tabList: [],
    authenticationState: '',
    companyName: '',
    //公司id
    id: '',
    navHeight: '',
    menus: {},
    isPersonage: false,
    isAffirmWeChatReplacePay:false
  },
  mutations: {
    saveMenus(state, v) {
      state.menus = v
    },
    navHeight(state, v) {
      state.navHeight = v
    },
    change(state, v) {
      state.id = v.id
      state.companyName = v.companyName
      state.authenticationState = v.authenticationState
      state.isPersonage = v.isPersonage
      state.isAffirmWeChatReplacePay=v.isAffirmWeChatReplacePay
    },
    WeChatReplacePay(state, v) {
      state.isAffirmWeChatReplacePay = v
    },
    addTab: (state, tab) => {
      // 如果tab已经存在，不添加新的tabs
      if (state.tabList.some((item) => item.path === tab.path)) return
      state.tabList.push(tab)
    }
  },
  getters: {
    // 获取tbsList
    getTabs: (state) => {
      return state.tabList
    }
  },
  actions: {},
  modules: {}
})
